// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610051843/js/" + chunkId + "." + {"44":"ee834d28","225":"0f2c9583","481":"e1682bb9","486":"66ad9726","770":"3521adb5"}[chunkId] + ".0.09569517104427994.chunk.js";
};